export default __webpack_public_path__ + "static/media/Bg.d92cd99e.png";